import { getItemOrDefaultToValue, getPersonName } from 'utils/details';
import { displayTime } from 'utils/time';
import {
  BASE_TRIP_STATUS,
  BASE_TRANSPORT_TYPE,
} from 'utils/constants/transport';
import { DEFAULT_EMPTY_VALUE } from '../../constants';
import { PAGE_URLS } from 'utils/constants';
//

export const transformTripsList = (trips, timeZone) => {
  return trips.map(trip => ({
    id: trip.id,
    tripId: trip.tripId,
    pageName: PAGE_URLS.TRIPS.link,
    passenger: trip.passenger
      ? getPersonName(trip.passenger.user.general)
      : DEFAULT_EMPTY_VALUE,
    pickUpPoint: trip.plannedRoute
      ? getItemOrDefaultToValue(
          trip.plannedRoute.pickUpLocation,
          'address',
          DEFAULT_EMPTY_VALUE,
        )
      : DEFAULT_EMPTY_VALUE,
    destination: trip.plannedRoute.route
      ? getItemOrDefaultToValue(
          trip.plannedRoute.route[trip.plannedRoute.route.length - 1],
          'address',
          DEFAULT_EMPTY_VALUE,
        )
      : DEFAULT_EMPTY_VALUE,
    tripType: trip.tripType
      ? BASE_TRANSPORT_TYPE[trip.tripType.serviceType].value
      : DEFAULT_EMPTY_VALUE,
    estimatedPrice: trip.tripType.estimatedPrice
      ? getItemOrDefaultToValue(
          trip.tripType,
          'estimatedPrice',
          DEFAULT_EMPTY_VALUE,
        )
      : DEFAULT_EMPTY_VALUE,
    actualPrice: trip.actualPrice
      ? getItemOrDefaultToValue(trip, 'actualPrice', DEFAULT_EMPTY_VALUE)
      : DEFAULT_EMPTY_VALUE,

    driver: trip.driver
      ? getPersonName(trip.driver.user.general)
      : DEFAULT_EMPTY_VALUE,
    driverId: trip.driver ? trip.driver.user.general.id : DEFAULT_EMPTY_VALUE,
    lastUpdatedTime: displayTime({
      timestamp: getItemOrDefaultToValue(trip, 'currentStatusTimestamp'),
      timeZone,
    }),
    pickUpTime: displayTime({
      timestamp: getItemOrDefaultToValue(trip, 'pickUpTime'),
      timeZone,
    }),
    dropOffTime: displayTime({
      timestamp: getItemOrDefaultToValue(trip, 'destinationTime'),
      timeZone,
    }),
    status: BASE_TRIP_STATUS[trip.currentStatus].value,
    pickUpLocation: trip.plannedRoute
      ? getItemOrDefaultToValue(trip.plannedRoute.pickUpLocation, 'point')
      : undefined,
  }));
};
